module.exports = __webpack_public_path__ + "static/media/Asil.6d4823f9.jpg";